import { render, staticRenderFns } from "./LayoutError.vue?vue&type=template&id=4e279733&"
import script from "./LayoutError.vue?vue&type=script&lang=js&"
export * from "./LayoutError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports